<template>
  <div class="content" v-if="!loading && orders">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:let;margin-top:5px;">Pedidos de Resgate de Clube Fidelidade</span>
    </div>
    
    <div class="line">
      <div style="padding:10px; ">
        <table border="1" cellpadding="5px" style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;width:100%">
          <thead>
            <tr>
              <td style="width:120px;text-align:center;">Data</td>
              <td style="text-align:center;">Status</td>
              <td style="text-align:center;">Lista de Prêmios</td>
              <td style="text-align:center;">Total de Pontos</td>
              <td style="width:50px;text-align:center;">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, idx) in orders" v-bind:key="idx">
              <td>{{formatDateTime(order.creation_date)}}</td>
              <td style="width:170px;text-align:center;">
                <select :style="{background:(order.status === 'PLACED' ? '#ffe8ce' : '#c6eaaf')}" style="height:28px;font-family:Roboto;font-size:12px; width:150px;height:30px;"  v-model="order.status" @change="changeOrderStatus(order)">
                  <option :selected="order.status === 'PLACED'" value="PLACED">Solicitado</option>
                  <option :selected="order.status === 'DISPATCHED'" value="DISPATCHED">Entregue</option>
                </select>
              </td>
              <td>
                <li v-for="(prize, idxp) in order.cart_prize_list" v-bind:key="idxp">
                  {{prize.quantity}}x - {{prize.prize_name}}
                </li>
              </td>
              <td style="width:150px;text-align:right;">{{order.total_points}}</td>
              <td style="text-align:center;">
                <a @click="openModalOrder(order)">
                  <font-awesome-icon style="font-size:18px;color:#12FCC4;margin:5px;"  :icon="['fal', 'info-circle']"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <OpaModal v-if="tempOrder && users" width="900" height="540" v-model="modalOrder" header="Detalhes do Resgate">
      <div style="height:380px;overflow:auto; padding:20px;width:100%">
        <div style="width:calc(40% - 20px);padding:10px;float:left;border-right:1px solid #ffffff;">
          <template v-if="tempOrder.user">
            <b>Situação:</b> {{(tempOrder.status === 'PLACED' ? 'Solicitado' : 'Entregue')}}<br/><br/>
            <b>Nome do CLiente:</b> {{tempOrder.user.name}}<br/><br/>
            <b>Telefone:</b> {{tempOrder.user.phone}}<br/><br/>
            <b>Email:</b> {{tempOrder.user.email}}<br/><br/>
          </template>
          <template v-if="tempOrder.delivery_address">
            <b>Endereço de Entrega:</b> <br/>{{tempOrder.delivery_address.name}}, {{tempOrder.delivery_address.streetNumber}}<br/>
            <i>complemento:</i> {{tempOrder.delivery_address.more}} <br/>
            <i>bairro:</i> {{tempOrder.delivery_address.vicinity}}<br/>
            <i>cidade:</i> {{tempOrder.delivery_address.city}} - <i>estado:</i> {{tempOrder.delivery_address.state}} <br/>
            <i>CEP:</i> {{tempOrder.delivery_address.cep}} - <i>país:</i> {{tempOrder.delivery_address.country}} 
          </template>
        </div>
        <div style="width:calc(60% - 22px);padding:10px;float:left;">
          <b>Prêmios: </b><br/><br/>
          <table style="border: 1px solid #ffffff;border-collapse:collapse;width:calc(100% - 30px);">
            <tr>
              <td>Nome</td>
              <td>Quantidade</td>
            </tr>
            <tr v-for="(p, ixp) in tempOrder.cart_prize_list" v-bind:key="ixp">
              <td style="border-bottom:1px solid #ffffff;">{{p.prize_name}}</td>
              <td style="border-bottom:1px solid #ffffff;">{{p.quantity}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonWire" style="width:80px;float:right;margin:20px;" @click="resetTempOrder(); modalOrder=false">Cancelar</button>
      </div>
    </OpaModal>
  </div>
  <div v-else></div>
</template>

<script>
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import MembershipConn from '@/connection/membership'
import UsersConn from '@/connection/users'
import formater from '@/mixins/formater'

export default {
  name: 'Banners',
  data () {
    return {
      users: null,
      orders: null,
      loading: true,
      tempOrder: null,
      modalOrder: false
    }
  },

  mixins: [formater],

  components: {OpaModal},
   
  created () {
    if (this.loading) {
      EventBus.$emit('showLoading', true)
    }
    this.resetTempOrder()
    this.loadUsers()
    this.loadOrders()
    
  },

  methods: {
    async loadUsers () {
      let result = await UsersConn.getUsersByCompany()
      if (result.error) {
        this.users = []
      } else {
        this.users = result
      }
    },

    async loadOrders () {
      let result = await MembershipConn.getOrderList()
      if (result.error) {
        this.orders = []
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        result.sort((a, b) => b.creation_date - a.creation_date)
        this.orders = result
      }
      this.loading = false
      EventBus.$emit('showLoading', false)

    },

    resetTempOrder () {
      this.tempOrder = {
        cart_prize_list: [],
        company_id: null,
        creation_date: null,
        delivery_address: null,
        id: null,
        partition_key: null,
        status: null,
        total_points: 0,
        user_id: null
      }
    },

    openModalOrder (order) {
      this.tempOrder = order
      this.tempOrder.user = this.users.filter(u => u.id === order.user_id)[0]
      this.modalOrder = true
    },

    async changeOrderStatus (order) {
      console.log(order.status)
      EventBus.$emit('showLoading', true)
      let result = await MembershipConn.updateOrderStatus(order.id, order.status)
      EventBus.$emit('showLoading', false)
      if (!result.error){
        EventBus.$emit('showAlert', 'success', 'Configurações atualizadas!')
      } else {
        EventBus.$emit('showAlert', 'error', 'Erro ao atualizar status')
      }
    }

  }
}
</script>

<style> 
a {
  cursor:pointer;
}
</style>